module.exports = __webpack_public_path__ + "roboto-medium-webfont-f407ec033f15172c3c4acf75608dd11d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-medium-webfont.svg
// module id = 863
// module chunks = 86